export enum AlertType {
    SUCCESS = 'success',
    WARNING = 'warning',
    INFO = 'info'
}
